module.exports = __webpack_public_path__ + "static/media/projects_thumb_k12_site_2x.54a80da4.jpg";